(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };

        if (!this.elements.input || !this.elements.button || !this.elements.panel) return;

        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.querySelectorAll('a[data-value]').forEach((item) => {
          item.addEventListener('click', this.onItemClick.bind(this));
        });
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', '');
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        this.elements.input.value = event.currentTarget.dataset.value;
        const form = this.querySelector('form');
        if (form) form.submit();
      }

      openSelector() {
        const isOpen = this.elements.button.getAttribute('aria-expanded') === 'true';
        this.elements.button.setAttribute('aria-expanded', (!isOpen).toString());
        this.elements.panel.toggleAttribute('hidden', isOpen);
      }

      closeSelector(event) {
        if (!this.contains(event.relatedTarget)) this.hidePanel();
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Sticky header (unchanged from Dawn logic) X*/
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }
    connectedCallback(){
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }
    setHeaderHeight(){ document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback(){
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver(){
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset(){ if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
    closeMenuDisclosure(){ this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(d => d.close()); }
    closeSearchModal(){ this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  /* SINGLE FIXED Drawer function - handles all drawer functionality */
  (function(){
    const details  = document.getElementById('Details-menu-drawer-container');
    if (!details) return;

    const drawer   = document.getElementById('menu-drawer');
    const backdrop = details.querySelector('.menu-drawer__backdrop');
    const closeBtn = details.querySelector('.menu-drawer__close-btnx');

    /* --- FIXED body scroll lock helpers --- */
    function lockBodyScroll(){
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.dataset.scrollY = y;
      
      // Add all necessary classes
      document.documentElement.classList.add('drawer-open');
      document.body.classList.add('drawer-open');
      document.body.classList.add('overflow-hidden-tablet');
      
      /* Fix the visual position while locking */
      document.body.style.position = 'fixed';
      document.body.style.top = `-${y}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockBodyScroll(){
      const y = parseInt(document.body.dataset.scrollY || '0', 10);
      
      // CRITICAL: Remove ALL locking classes
      document.documentElement.classList.remove('drawer-open');
      document.body.classList.remove('drawer-open');
      document.body.classList.remove('overflow-hidden-tablet');
      
      // Clear all inline styles
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      delete document.body.dataset.scrollY;
      
      // Restore scroll position
      window.scrollTo(0, y);
    }

    function closeDrawer(){
      details.removeAttribute('open');
      // Force unlock even if toggle doesn't fire
      setTimeout(unlockBodyScroll, 10);
    }

    function stop(e){ 
      e.stopPropagation(); 
    }

    /* Close methods (X + backdrop) */
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    /* Prevent clicks inside panel from toggling details */
    if (drawer) drawer.addEventListener('click', stop);

    /* ESC to close */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && details.hasAttribute('open')) closeDrawer();
    });

    /* HARD BLOCK any wheel/touch scroll within the drawer */
    const blockIfOpen = (e) => {
      if (details.hasAttribute('open')) e.preventDefault();
    };
    ['wheel','touchmove'].forEach(type => {
      if (drawer) drawer.addEventListener(type, blockIfOpen, { passive: false });
    });

    /* When <details> opens/closes (user or script), lock/unlock body */
    details.addEventListener('toggle', () => {
      if (details.hasAttribute('open')) {
        lockBodyScroll();
      } else {
        unlockBodyScroll();
      }
    });

    /* Safety cleanup on visibility change */
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && document.body.classList.contains('drawer-open')) {
        unlockBodyScroll();
      }
    });
  })();


  } catch(e) { console.error(e); }
})();
})();
